import { render } from "./PagesDropdown.vue?vue&type=template&id=a28155dc&scoped=true"
import script from "./PagesDropdown.vue?vue&type=script&lang=js"
export * from "./PagesDropdown.vue?vue&type=script&lang=js"

import "./PagesDropdown.vue?vue&type=style&index=0&id=a28155dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28155dc"]])

export default __exports__